import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Typography from '@mui/material/Typography';

import {
  MdDashboard,
  MdOutlineAttachMoney,
  MdPendingActions,
  MdPermMedia,
  MdSource,
} from 'react-icons/md';

import { TourPayables } from './components/TourPayables';
import { TourBudgets } from './components/TourBudgets';
import { TourSchedule } from './components/TourSchedule';
import { TourPhotos } from './components/TourPhotos';
import { TourDocuments } from './components/TourDocuments';
import { TourDashboard } from './components/TourDashboard';

import { Header } from '../../../../components/singleComponents/headers/index';
import { RootStyled, TabListStyled, TabStyled } from './index.styles';

const headings = [
  {
    title: 'Lançamentos',
    icon: <MdSource size={18} />,
    value: 'payables',
    id: 'payables-tab',
  },
  {
    title: 'Orçamentos',
    icon: <MdOutlineAttachMoney size={18} />,
    value: 'budgets',
    id: 'budgets-tab',
  },
  {
    title: 'Cronograma',
    icon: <MdPendingActions size={18} />,
    value: 'schedules',
    id: 'schedules-tab',
  },
  {
    title: 'Fotos',
    icon: <MdPermMedia size={18} />,
    value: 'photos',
    id: 'photos-tab',
  },
  {
    title: 'Documentos',
    icon: <MdSource size={18} />,
    value: 'documents',
    id: 'documents-tab',
  },
  {
    title: 'Dashboard',
    icon: <MdDashboard size={18} />,
    value: 'dashboard',
    id: 'dashboard-tab',
  },
];

export function ConstructionsTour() {
  const navigate = useNavigate();
  const { page } = useParams();

  const [selectedTab, setSelectedTab] = React.useState(page);

  const handleChange = (_event, newValue) => {
    navigate(`/constructions/tour/${newValue}`);
  };

  useEffect(() => {
    setSelectedTab(page);
  }, [page]);

  return (
    <>
      <Header />
      <RootStyled>
        <TabListStyled
          value={selectedTab}
          onChange={handleChange}
          variant="fullWidth"
        >
          {headings.map((heading) => (
            <TabStyled
              key={heading.title}
              value={heading.value}
              label={heading.title}
              icon={heading.icon}
              iconPosition="start"
            >
              <Typography>{heading?.icon}</Typography>
              <Typography style={{ fontSize: '14px' }}>
                {heading.title}
              </Typography>
            </TabStyled>
          ))}
        </TabListStyled>
        {selectedTab === 'payables' && <TourPayables />}
        {selectedTab === 'budgets' && <TourBudgets />}
        {selectedTab === 'schedules' && <TourSchedule />}
        {selectedTab === 'photos' && <TourPhotos />}
        {selectedTab === 'documents' && <TourDocuments />}
        {selectedTab === 'dashboard' && <TourDashboard />}
      </RootStyled>
    </>
  );
}
